import { inject, Injectable, signal } from '@angular/core';
import { EntityDetailStore } from '@webapp/core/stores/entity-detail-store.service';
import { EntityListStore } from '@webapp/core/stores/entity-list-store.service';
import { PaginationParams } from '@webapp/core/ui/components/pagination/pagination.interfaces';
import { firstValueFrom, map } from 'rxjs';
import { buildStatus } from '../common/map';
import { IPolicy, IPolicyRow } from '../interfaces/policies.interface';
import { PoliciesService } from '../services/policies.service';
import { IBasePolicy, Policy } from '../interfaces/policies.interface';
import { MapPolicy } from '../mappers/policyMap';
export type MappedPolicyDetail = IPolicy & {
	insurable: Policy['insurable'];
	title: string;
	badgeStatus: string;
	badgeText: string;
};


@Injectable({
	providedIn: 'root',
})
export class PoliciesStoreService {
	listStore: EntityListStore<IPolicyRow>;
	detailStore: EntityDetailStore<IBasePolicy>;
	service = inject(PoliciesService);
	loadingDownload = signal(false);

	constructor() {
		this.listStore = new EntityListStore((params: PaginationParams) =>
			firstValueFrom(
				this.service.get(params).pipe(
					map(res => ({
						...res,
						data: res.data.map(policy => ({
							...policy,
							...buildStatus(policy.status),
						})),
					}))
				)
			)
		);

		this.detailStore = new EntityDetailStore<IBasePolicy>((id: string) =>
			firstValueFrom(
				this.service.getById(id).pipe(
					map(res => {
						const mapped = MapPolicy(res as unknown as Policy);

						return {
							...res,
							...mapped,
							...buildStatus(res?.status),
						};
					})
				)
			)
		);

	}

	public getRows() {
		return this.listStore.select('rows');
	}

	public get() {
		return this.detailStore.select('selected');
	}

	async addGarage(id: string) {
		return await firstValueFrom(
			this.service.addGarage(id).pipe(
				map(res => {
					return res.data
				})
			)
		)
	}

	

	async download() {
		const entity = this.get()();
		if (!entity) {
			return;
		}

		this.loadingDownload.set(true);
		const blob = await firstValueFrom(this.service.download(entity.id));
		this.loadingDownload.set(false);
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `poliza_No_${entity.internalNumber}_${new Date().toISOString().split('T')[0]}.pdf`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	}
}
